import {
	IMobileScansListQuery,
	IMobileScansListRawRow,
	IMobileScansListRawSummary,
	IMobileScansListResult,
	IMobileScansListRow,
	MobileScansProductType
} from '../MobileScansList.types';

const isMobileScansListRawRow = (
	scan: IMobileScansListRawRow | null
): scan is IMobileScansListRawRow => !!scan;

export const transformMobileScansListResults = (
	rawResults: IMobileScansListQuery,
	productName: MobileScansProductType | undefined
): IMobileScansListResult => {
	const rows: IMobileScansListRow[] =
		(rawResults.mfa_scans_list ?? rawResults.msdk_scans_list)
			?.filter(isMobileScansListRawRow)
			.map((scan) => ({
				productName: productName as MobileScansProductType,
				runId: scan.run_id,
				scanId: scan.scan_id,
				scanName: scan.scan_name,
				scanCreatedAt: scan.scan_created_at,
				scanScreenshotUrl: scan.scan_screenshot_url,
				totalIssues: scan.total_issues,
				criticalIssues: scan.critical_issues,
				seriousIssues: scan.serious_issues,
				elementsWithIssues: scan.elements_with_issues
			})) ?? [];

	const summaryRows = (rawResults.total ?? []).filter(
		(row): row is IMobileScansListRawSummary => row !== null
	);
	const { issuesCount, elementsWithIssuesCount } = summaryRows.reduce(
		(acc, row) => ({
			issuesCount: acc.issuesCount + (row.total_issues ?? 0),
			elementsWithIssuesCount: acc.elementsWithIssuesCount + (row.elements_with_issues ?? 0)
		}),
		{ issuesCount: 0, elementsWithIssuesCount: 0 }
	);
	const summary = {
		scansCount: summaryRows.length,
		issuesCount,
		elementsWithIssuesCount
	};

	return {
		rows,
		total: summary.scansCount,
		summary
	};
};
